module.exports = __webpack_public_path__ + "static/media/tree-view-active.9e04a756.svg";